<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    bottom
    offset-y
    max-width="290px"
    min-width="290px"
    nudge-bottom="-25px"
    :disabled="disabled">
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="valueText"
        @click.prevent.stop="on.click"
        @change="textFieldChange"
        @blur="$emit('blur', $event)"
        :error-messages="errorMessages"
        :disabled="disabled"
        class="date-menu-input"
        solo>
        <template slot="append-outer">
          <image-button class="date-menu-button"
            @click.prevent.stop="on.click"
            @keydown.prevent.stop="on.keydown"
            icon
            :disabled="disabled"
            :image="coloredAssetUrls.calendar"/>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      class="date-menu-picker"
      :color="colorHex"
      :value="valueDate"
      @input="datePickerInput"
      @change="datePickerChange"
      @blur="$emit('blur', $event)"
      :disabled="disabled"/>
  </v-menu>
</template>

<script>
import imageButton from "./ImageButton";
import { formatDateDisplay, displayDateFormat, isoDateFormat } from "../../helpers/dateUtils";
import moment from "moment";

export default {
  name: "dateMenu",
  components: { imageButton },
  props: [
    "value",
    "name",
    "errorMessages",
    "disabled"
  ],
  data() {
    return {
      menu: false
    };
  },
  computed:{
    valueMoment(){
      return this.value ? moment(this.value, isoDateFormat, true) : null;
    },
    valueValid(){
      return this.valueMoment && this.valueMoment.isValid();
    },
    valueText(){
      return this.valueValid ? formatDateDisplay(this.value) : this.value;
    },
    valueDate(){
      return this.valueValid ? this.value : "";
    }
  },
  methods: {
    datePickerChange(dateValue){
      this.menu = false;
      this.$emit("change", dateValue);
    },
    datePickerInput(dateValue) {
      this.menu = false;
      this.$emit("input", dateValue);
    },
    textFieldChange(dateValue){
      let date = "";
      if (dateValue){
        // Removed strict check to allow for 2/4 digit years as valid input
        let m = moment(dateValue, displayDateFormat);
        date = m.format(isoDateFormat);
      }
      this.datePickerChange(date);
    }
  }
};
</script>